import Common from '../Common';

interface ForgotPassword {
	alias: string
}

interface PasswordReset {
	key: string
	password: string
}

const ResetPassword = class extends Common {
	forgotPassword = (body: ForgotPassword) =>
		this.postNoHeaders("/passwordreset/forgottenpassword", body)

	completePasswordReset = (body: PasswordReset) =>
		this.postNoHeaders("/passwordreset/resetpassword", body)
}

export default ResetPassword;
